
import {
  CheckCircle2,
  XCircle,
  Clock,
  Archive,
} from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import type { ExtensionStatus } from '@/lib/types'

interface ExtensionStatusBadgeProps {
  status: ExtensionStatus
}

export function ExtensionStatusBadge({ status }: ExtensionStatusBadgeProps) {
  const styles = {
    approved: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 border-green-200 dark:border-green-800',
    pending: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 border-amber-200 dark:border-amber-800',
    rejected: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 border-red-200 dark:border-red-800',
    suspended: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-400 border-slate-200 dark:border-slate-700',
    archived: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-500 border-slate-200 dark:border-slate-700',
  }

  const icons = {
    approved: CheckCircle2,
    pending: Clock,
    rejected: XCircle,
    suspended: Archive,
    archived: Archive,
  }

  const Icon = icons[status] || Clock

  return (
    <Badge variant="outline" className={`font-normal ${styles[status]}`}>
      <Icon className="mr-1 h-3 w-3" />
      <span className="capitalize">{status}</span>
    </Badge>
  )
}
